import React, { useEffect, useMemo, useState } from "react";
import Input from "../../extra/Input";
import {
  getSettingApi,
  editSetting,
  switchApi,
  getAdsApi,
  isAdsChange,
  adsApiData,
  getWithdrawalApi,
} from "../../store/setting/setting.action";
import { FormControlLabel, Switch } from "@mui/material";
import styled from "@emotion/styled";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";

import { getDefaultCurrency } from "../../store/currency/currency.action";
import InfoTooltip from "../../extra/InfoTooltip";
import { androidAdsContent, iosAdsContent, imaAdsTagsContent } from "../../extra/infoContent";

/* Styled switch (correct mode check) */
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 76,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    top: 8,
    transform: "translateX(10px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(38px)",
      top: 8,
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.5992 5.06724C16.396 4.86409 16.1205 4.75 15.8332 4.75c-.2872 0-.5627.11409-.7659.31719L7.9166 12.2179 4.934 9.2353a1.17 1.17 0 0 0-1.7801 1.532l3.7486 3.7486c.2031.2031.4786.3172.7659.3172s.5627-.1141.7659-.3172l7.9167-7.9167c.2031-.20315.3172-.47865.3172-.76591 0-.28727-.1141-.56277-.3172-.76592Z" fill="white" stroke="white" stroke-width="0.5"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor:
          theme?.palette?.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme?.palette?.mode === "dark" ? "#0FB515" : "red",
    width: 24,
    height: 24,
    "&:before": {
      content: "''",
      position: "absolute",
      inset: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M14.1665 5.83301 5.83325 14.1663" stroke="white" stroke-width="2.5" stroke-linecap="round"/><path d="M5.83325 5.83301 14.1665 14.1663" stroke="white" stroke-width="2.5" stroke-linecap="round"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    border: "0.5px solid rgba(0,0,0,0.14)",
    background: "#FFEDF0",
    boxShadow: "inset 0 0 2px rgba(0,0,0,0.08)",
    opacity: 1,
    width: 60,
    height: 28,
    borderRadius: 52,
  },
}));

const MonetizationSetting = (props) => {
  const dispatch = useDispatch();
  const { settingData, adsData } = useSelector((s) => s.setting);
  const { defaultCurrency } = useSelector((s) => s.currency);

 

  /* Monetize state */
  const [data, setData] = useState(null);

  const [originalData, setOriginalData] = useState({});
  const [isMonetization, setIsMonetization] = useState(false);
  const [minWatchTime, setMinWatchTime] = useState(0);
  const [minSubScriber, setMinSubScriber] = useState(0);
  const [earningPerHour, setEarningPerHour] = useState(0);
  const [adDisplayIndex, setAdDisplayIndex] = useState(1);

  /* Ads state (Android) */
  const [androidGoogleInterstitial, setAndroidGoogleInterstitial] = useState("");
  const [androidGoogleNative, setAndroidGoogleNative] = useState("");
  const [androidGoogleNativeVideo, setAndroidGoogleNativeVideo] = useState("");
  const [androidGoogleReward, setAndroidGoogleReward] = useState("");
  const [androidVideoAdUrl, setAndroidVideoAdUrl] = useState(""); // NEW (flat submit)

  /* Ads state (iOS) */
  const [iosGoogleInterstitial, setIosGoogleInterstitial] = useState("");
  const [iosGoogleNative, setIosGoogleNative] = useState("");
  const [iosGoogleNativeVideo, setIosGoogleNativeVideo] = useState("");
  const [iosGoogleReward, setIosGoogleReward] = useState("");
  const [iosVideoAdUrl, setIosVideoAdUrl] = useState(""); // NEW (flat submit)

  /* IMA Tags (comma-separated in API: imaTagsUrl) */
  const [imaTagUrl1, setImaTagUrl1] = useState("");
  const [imaTagUrl2, setImaTagUrl2] = useState("");
  const [imaTagUrl3, setImaTagUrl3] = useState("");

  const [googleAds, setGoogleAds] = useState(false);
  const [originalAdsData, setOriginalAdsData] = useState({});

  /* Multi-network ad controls */
  const [levelPlayAds, setLevelPlayAds] = useState(false);
  const [pangleAds, setPangleAds] = useState(false);
  const [inMobiAds, setInMobiAds] = useState(false);
  const [appodealAds, setAppodealAds] = useState(false);
  const [metaAds, setMetaAds] = useState(false);
  const [topOnAds, setTopOnAds] = useState(false);

  /* TopOn (Android only) — keys match the backend's androidTopOn<Field> body keys */
  const topOnFields = [
    ["appId", "App ID"],
    ["appKey", "App Key"],
    ["interstitial", "Interstitial"],
    ["reward", "Reward"],
    ["banner", "Banner"],
    ["native", "Native"],
  ];
  const [androidTopOn, setAndroidTopOn] = useState({});

  /* Meta (Android/iOS) */
  const [androidMetaAppId, setAndroidMetaAppId] = useState("");
  const [androidMetaInterstitial, setAndroidMetaInterstitial] = useState("");
  const [androidMetaReward, setAndroidMetaReward] = useState("");
  const [androidMetaBanner, setAndroidMetaBanner] = useState("");
  const [androidMetaNative, setAndroidMetaNative] = useState("");

  const [iosMetaAppId, setIosMetaAppId] = useState("");
  const [iosMetaInterstitial, setIosMetaInterstitial] = useState("");
  const [iosMetaReward, setIosMetaReward] = useState("");
  const [iosMetaBanner, setIosMetaBanner] = useState("");
  const [iosMetaNative, setIosMetaNative] = useState("");

  /* Appodeal */
  const [appodealAndroidAppKey, setAppodealAndroidAppKey] = useState("");
  const [appodealIosAppKey, setAppodealIosAppKey] = useState("");
  const [appodealTestMode, setAppodealTestMode] = useState(false);

  const [appodealInterstitialEnabled, setAppodealInterstitialEnabled] = useState(true);
  const [appodealInterstitialPlacement, setAppodealInterstitialPlacement] = useState("default");

  const [appodealRewardedEnabled, setAppodealRewardedEnabled] = useState(true);
  const [appodealRewardedPlacement, setAppodealRewardedPlacement] = useState("default");

  const [appodealBannerEnabled, setAppodealBannerEnabled] = useState(true);
  const [appodealBannerPlacement, setAppodealBannerPlacement] = useState("default");

  const [appodealMrecEnabled, setAppodealMrecEnabled] = useState(false);
  const [appodealMrecPlacement, setAppodealMrecPlacement] = useState("default");

  const [adNetworkRewarded, setAdNetworkRewarded] = useState("google");
  const [adNetworkInterstitial, setAdNetworkInterstitial] = useState("google");
  const [adNetworkNative, setAdNetworkNative] = useState("google");
  const [adNetworkBanner, setAdNetworkBanner] = useState("google");

  /* LevelPlay (Android/iOS) */
  const [androidLevelPlayAppKey, setAndroidLevelPlayAppKey] = useState("");
  const [androidLevelPlayReward, setAndroidLevelPlayReward] = useState("");
  const [androidLevelPlayInterstitial, setAndroidLevelPlayInterstitial] = useState("");
  const [androidLevelPlayBanner, setAndroidLevelPlayBanner] = useState("");
  const [androidLevelPlayNative, setAndroidLevelPlayNative] = useState("");
  const [iosLevelPlayAppKey, setIosLevelPlayAppKey] = useState("");
  const [iosLevelPlayReward, setIosLevelPlayReward] = useState("");
  const [iosLevelPlayInterstitial, setIosLevelPlayInterstitial] = useState("");
  const [iosLevelPlayBanner, setIosLevelPlayBanner] = useState("");
  const [iosLevelPlayNative, setIosLevelPlayNative] = useState("");

  /* Pangle (Android/iOS) */
  const [androidPangleAppId, setAndroidPangleAppId] = useState("");
  const [androidPangleReward, setAndroidPangleReward] = useState("");
  const [androidPangleInterstitial, setAndroidPangleInterstitial] = useState("");
  const [androidPangleBanner, setAndroidPangleBanner] = useState("");
  const [androidPangleNative, setAndroidPangleNative] = useState("");
  const [iosPangleAppId, setIosPangleAppId] = useState("");
  const [iosPangleReward, setIosPangleReward] = useState("");
  const [iosPangleInterstitial, setIosPangleInterstitial] = useState("");
  const [iosPangleBanner, setIosPangleBanner] = useState("");
  const [iosPangleNative, setIosPangleNative] = useState("");

  /* InMobi (Android/iOS) */
  const [androidInMobiAccountId, setAndroidInMobiAccountId] = useState("");
  const [androidInMobiReward, setAndroidInMobiReward] = useState("");
  const [androidInMobiInterstitial, setAndroidInMobiInterstitial] = useState("");
  const [androidInMobiBanner, setAndroidInMobiBanner] = useState("");
  const [androidInMobiNative, setAndroidInMobiNative] = useState("");
  const [iosInMobiAccountId, setIosInMobiAccountId] = useState("");
  const [iosInMobiReward, setIosInMobiReward] = useState("");
  const [iosInMobiInterstitial, setIosInMobiInterstitial] = useState("");
  const [iosInMobiBanner, setIosInMobiBanner] = useState("");
  const [iosInMobiNative, setIosInMobiNative] = useState("");

  const [error, setError] = useState({
    minWatchTime: "",
    minSubScriber: "",
    earningPerHour: "",
    adDisplayIndex: "",
  });

  /* Bootstrap */
  useEffect(() => {
    
    dispatch(getSettingApi());
    dispatch(getDefaultCurrency());
    dispatch(getAdsApi());
  }, [dispatch]);

  /* Store → local (Monetize) */
  useEffect(() => {
    if (!settingData) return;
    setData(settingData);
    setIsMonetization(Boolean(settingData?.isMonetization));
    setMinWatchTime(Number(settingData?.minWatchTime || 0));
    setMinSubScriber(Number(settingData?.minSubScriber || 0));
    setEarningPerHour(Number(settingData?.earningPerHour || 0));
    setAdDisplayIndex(
      Number.isFinite(Number(settingData?.adDisplayIndex))
        ? Number(settingData?.adDisplayIndex)
        : 1
    );

    // Set original data for comparison
    setOriginalData({
      minWatchTime: Number(settingData?.minWatchTime || 0),
      minSubScriber: Number(settingData?.minSubScriber || 0),
      earningPerHour: Number(settingData?.earningPerHour || 0),
      adDisplayIndex: Number.isFinite(Number(settingData?.adDisplayIndex))
        ? Number(settingData?.adDisplayIndex)
        : 1,
    });
  }, [settingData]);

  /* Store → local (Ads, read nested, keep flat state) */
  useEffect(() => {
    if (!adsData) return;

    setAndroidGoogleInterstitial(adsData?.android?.google?.interstitial || "");
    setAndroidGoogleNative(adsData?.android?.google?.native || "");
    setAndroidGoogleNativeVideo(adsData?.android?.google?.nativeAdVideo || "");
    setAndroidGoogleReward(adsData?.android?.google?.reward || "");
    setAndroidVideoAdUrl(adsData?.android?.google?.videoAdUrl || ""); // NEW

    setIosGoogleInterstitial(adsData?.ios?.google?.interstitial || "");
    setIosGoogleNative(adsData?.ios?.google?.native || "");
    setIosGoogleNativeVideo(adsData?.ios?.google?.nativeAdVideo || "");
    setIosGoogleReward(adsData?.ios?.google?.reward || "");
    setIosVideoAdUrl(adsData?.ios?.google?.videoAdUrl || ""); // NEW

    const rawImaTags =
      adsData?.imaTagsUrl ??
      adsData?.google?.imaTagsUrl ??
      adsData?.android?.google?.imaTagsUrl ??
      "";
    const parsedImaTags = String(rawImaTags)
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    setImaTagUrl1(parsedImaTags[0] || "");
    setImaTagUrl2(parsedImaTags[1] || "");
    setImaTagUrl3(parsedImaTags[2] || "");

    setGoogleAds(Boolean(adsData?.isGoogle));

    setLevelPlayAds(Boolean(adsData?.isLevelPlay));
    setPangleAds(Boolean(adsData?.isPangle));
    setInMobiAds(Boolean(adsData?.isInMobi));
    setAppodealAds(
      Boolean(adsData?.isAppodeal || adsData?.appodeal?.enabled)
    );
    setMetaAds(Boolean(adsData?.isMeta));
    setTopOnAds(Boolean(adsData?.isTopOn));
    setAdNetworkRewarded(adsData?.adNetwork?.rewarded || "google");
    setAdNetworkInterstitial(adsData?.adNetwork?.interstitial || "google");
    setAdNetworkNative(adsData?.adNetwork?.native || "google");
    setAdNetworkBanner(adsData?.adNetwork?.banner || "google");

    setAndroidLevelPlayAppKey(adsData?.android?.levelPlay?.appKey || "");
    setAndroidLevelPlayReward(adsData?.android?.levelPlay?.reward || "");
    setAndroidLevelPlayInterstitial(adsData?.android?.levelPlay?.interstitial || "");
    setAndroidLevelPlayBanner(adsData?.android?.levelPlay?.banner || "");
    setAndroidLevelPlayNative(adsData?.android?.levelPlay?.native || "");
    setIosLevelPlayAppKey(adsData?.ios?.levelPlay?.appKey || "");
    setIosLevelPlayReward(adsData?.ios?.levelPlay?.reward || "");
    setIosLevelPlayInterstitial(adsData?.ios?.levelPlay?.interstitial || "");
    setIosLevelPlayBanner(adsData?.ios?.levelPlay?.banner || "");
    setIosLevelPlayNative(adsData?.ios?.levelPlay?.native || "");

    setAndroidPangleAppId(adsData?.android?.pangle?.appId || "");
    setAndroidPangleReward(adsData?.android?.pangle?.reward || "");
    setAndroidPangleInterstitial(adsData?.android?.pangle?.interstitial || "");
    setAndroidPangleBanner(adsData?.android?.pangle?.banner || "");
    setAndroidPangleNative(adsData?.android?.pangle?.native || "");
    setIosPangleAppId(adsData?.ios?.pangle?.appId || "");
    setIosPangleReward(adsData?.ios?.pangle?.reward || "");
    setIosPangleInterstitial(adsData?.ios?.pangle?.interstitial || "");
    setIosPangleBanner(adsData?.ios?.pangle?.banner || "");
    setIosPangleNative(adsData?.ios?.pangle?.native || "");

    setAndroidInMobiAccountId(adsData?.android?.inMobi?.accountId || "");
    setAndroidInMobiReward(adsData?.android?.inMobi?.reward || "");
    setAndroidInMobiInterstitial(adsData?.android?.inMobi?.interstitial || "");
    setAndroidInMobiBanner(adsData?.android?.inMobi?.banner || "");
    setAndroidInMobiNative(adsData?.android?.inMobi?.native || "");
    setIosInMobiAccountId(adsData?.ios?.inMobi?.accountId || "");
    setIosInMobiReward(adsData?.ios?.inMobi?.reward || "");
    setIosInMobiInterstitial(adsData?.ios?.inMobi?.interstitial || "");
    setIosInMobiBanner(adsData?.ios?.inMobi?.banner || "");
    setIosInMobiNative(adsData?.ios?.inMobi?.native || "");

    /* Meta */
    setAndroidMetaAppId(adsData?.android?.meta?.appId || "");
    setAndroidMetaInterstitial(adsData?.android?.meta?.interstitial || "");
    setAndroidMetaReward(adsData?.android?.meta?.reward || "");
    setAndroidMetaBanner(adsData?.android?.meta?.banner || "");
    setAndroidMetaNative(adsData?.android?.meta?.native || "");

    setIosMetaAppId(adsData?.ios?.meta?.appId || "");
    setIosMetaInterstitial(adsData?.ios?.meta?.interstitial || "");
    setIosMetaReward(adsData?.ios?.meta?.reward || "");
    setIosMetaBanner(adsData?.ios?.meta?.banner || "");
    setIosMetaNative(adsData?.ios?.meta?.native || "");

    /* TopOn */
    setAndroidTopOn(adsData?.android?.topOn || {});

    /* Appodeal */
    setAppodealAndroidAppKey(
      adsData?.appodeal?.androidAppKey ||
      adsData?.android?.appodeal?.appKey ||
      ""
    );

    setAppodealIosAppKey(
      adsData?.appodeal?.iosAppKey ||
      adsData?.ios?.appodeal?.appKey ||
      ""
    );

    setAppodealTestMode(Boolean(adsData?.appodeal?.testMode));

    setAppodealInterstitialEnabled(
      adsData?.appodeal?.interstitial?.enabled !== false
    );
    setAppodealInterstitialPlacement(
      adsData?.appodeal?.interstitial?.placement || "default"
    );

    setAppodealRewardedEnabled(
      adsData?.appodeal?.rewarded?.enabled !== false
    );
    setAppodealRewardedPlacement(
      adsData?.appodeal?.rewarded?.placement || "default"
    );

    setAppodealBannerEnabled(
      adsData?.appodeal?.banner?.enabled !== false
    );
    setAppodealBannerPlacement(
      adsData?.appodeal?.banner?.placement || "default"
    );

    setAppodealMrecEnabled(
      Boolean(adsData?.appodeal?.mrec?.enabled)
    );
    setAppodealMrecPlacement(
      adsData?.appodeal?.mrec?.placement || "default"
    );

    // Set original ads data for comparison
    setOriginalAdsData({
      androidGoogleInterstitial: adsData?.android?.google?.interstitial || "",
      androidGoogleNative: adsData?.android?.google?.native || "",
      androidGoogleNativeVideo: adsData?.android?.google?.nativeAdVideo || "",
      androidGoogleReward: adsData?.android?.google?.reward || "",
      androidVideoAdUrl: adsData?.android?.google?.videoAdUrl || "",
      iosGoogleInterstitial: adsData?.ios?.google?.interstitial || "",
      iosGoogleNative: adsData?.ios?.google?.native || "",
      iosGoogleNativeVideo: adsData?.ios?.google?.nativeAdVideo || "",
      iosGoogleReward: adsData?.ios?.google?.reward || "",
      iosVideoAdUrl: adsData?.ios?.google?.videoAdUrl || "",
      imaTagsUrl: String(rawImaTags || ""),
    });
  }, [adsData]);

  /* Helpers */
  const guardPermission = async () => {
    
    return true;
  };

  const validateMonetizeForm = () => {
    const errs = {};
    if (minWatchTime === "" || minWatchTime === null) {
      errs.minWatchTime = "Min Watch Time is required !";
    } else if (!Number.isFinite(Number(minWatchTime)) || Number(minWatchTime) <= 0) {
      errs.minWatchTime = "Min Watch Time must be > 0.";
    }

    if (minSubScriber === "" || minSubScriber === null) {
      errs.minSubScriber = "Min Subscriber is required !";
    } else if (!Number.isFinite(Number(minSubScriber)) || Number(minSubScriber) < 0) {
      errs.minSubScriber = "Min Subscriber must be ≥ 0.";
    }

    if (earningPerHour === "" || earningPerHour === null) {
      errs.earningPerHour = "Earning per hour is required !";
    } else if (!Number.isFinite(Number(earningPerHour)) || Number(earningPerHour) < 0) {
      errs.earningPerHour = "Earning per hour must be ≥ 0.";
    }

    if (adDisplayIndex === "" || adDisplayIndex === null) {
      errs.adDisplayIndex = "Ad Display Frequency is required !";
    } else if (
      !Number.isFinite(Number(adDisplayIndex)) ||
      Number(adDisplayIndex) <= 0
    ) {
      errs.adDisplayIndex = "Ad Display Frequency must be > 0.";
    }

    setError((prev) => ({ ...prev, ...errs }));
    return Object.keys(errs).length === 0;
  };

  /* Handlers */
  const handleSubmit = async () => {
    if (!(await guardPermission())) return;
    if (!validateMonetizeForm()) return;

    // Only send changed fields
    let payload = {};

    if (Number(minWatchTime) !== originalData.minWatchTime) {
      payload.minWatchTime = Number(minWatchTime);
    }
    if (Number(minSubScriber) !== originalData.minSubScriber) {
      payload.minSubScriber = Number(minSubScriber);
    }
    if (Math.max(1, Number(adDisplayIndex) || 1) !== originalData.adDisplayIndex) {
      payload.adDisplayIndex = Math.max(1, Number(adDisplayIndex) || 1);
    }
    if (Number(earningPerHour) !== originalData.earningPerHour) {
      payload.earningPerHour = Number(earningPerHour);
    }

    // If no changes, don't call API
    if (Object.keys(payload).length === 0) {
      return;
    }

    props.editSetting(data?._id, payload);
  };

  // ⬇️ Only send changed fields
  const handleSubmitAds = async () => {
    if (!(await guardPermission())) return;

    let adsDataApi = {};

    if (androidGoogleInterstitial !== originalAdsData.androidGoogleInterstitial) {
      adsDataApi.androidGoogleInterstitial = androidGoogleInterstitial;
    }
    if (androidGoogleNative !== originalAdsData.androidGoogleNative) {
      adsDataApi.androidGoogleNative = androidGoogleNative;
    }
    if (androidGoogleNativeVideo !== originalAdsData.androidGoogleNativeVideo) {
      adsDataApi.androidNativeAdVideo = androidGoogleNativeVideo;
    }
    if (iosGoogleNativeVideo !== originalAdsData.iosGoogleNativeVideo) {
      adsDataApi.iosNativeAdVideo = iosGoogleNativeVideo;
    }
    if (iosGoogleNative !== originalAdsData.iosGoogleNative) {
      adsDataApi.iosGoogleNative = iosGoogleNative;
    }
    if (iosGoogleInterstitial !== originalAdsData.iosGoogleInterstitial) {
      adsDataApi.iosGoogleInterstitial = iosGoogleInterstitial;
    }
    if (androidGoogleReward !== originalAdsData.androidGoogleReward) {
      adsDataApi.androidGoogleReward = androidGoogleReward;
    }
    if (iosGoogleReward !== originalAdsData.iosGoogleReward) {
      adsDataApi.iosGoogleReward = iosGoogleReward;
    }
    if (androidVideoAdUrl !== originalAdsData.androidVideoAdUrl) {
      adsDataApi.androidGoogleVideoAdUrl = androidVideoAdUrl;
    }
    if (iosVideoAdUrl !== originalAdsData.iosVideoAdUrl) {
      adsDataApi.iosGoogleVideoAdUrl = iosVideoAdUrl;
    }

    const nextImaTagsUrl = `${String(imaTagUrl1 || "").trim()},${String(
      imaTagUrl2 || ""
    ).trim()},${String(imaTagUrl3 || "").trim()}`;
    if (nextImaTagsUrl !== String(originalAdsData.imaTagsUrl || "")) {
      adsDataApi.imaTagsUrl = nextImaTagsUrl;
    }

    // multi-network selectors + ids (backend ignores empty id fields)
    Object.assign(adsDataApi, {
      adNetworkRewarded,
      adNetworkInterstitial,
      adNetworkNative,
      adNetworkBanner,
      androidLevelPlayAppKey, androidLevelPlayReward, androidLevelPlayInterstitial, androidLevelPlayBanner, androidLevelPlayNative,
      iosLevelPlayAppKey, iosLevelPlayReward, iosLevelPlayInterstitial, iosLevelPlayBanner, iosLevelPlayNative,
      androidPangleAppId, androidPangleReward, androidPangleInterstitial, androidPangleBanner, androidPangleNative,
      iosPangleAppId, iosPangleReward, iosPangleInterstitial, iosPangleBanner, iosPangleNative,
      androidInMobiAccountId, androidInMobiReward, androidInMobiInterstitial, androidInMobiBanner, androidInMobiNative,
      iosInMobiAccountId, iosInMobiReward, iosInMobiInterstitial, iosInMobiBanner, iosInMobiNative,

      androidMetaAppId,
      androidMetaInterstitial,
      androidMetaReward,
      androidMetaBanner,
      androidMetaNative,

      iosMetaAppId,
      iosMetaInterstitial,
      iosMetaReward,
      iosMetaBanner,
      iosMetaNative,

      ...Object.fromEntries(
        topOnFields.map(([key]) => [`androidTopOn${key[0].toUpperCase()}${key.slice(1)}`, androidTopOn[key] || ""])
      ),

      appodealAndroidAppKey,
      appodealIosAppKey,
      appodealTestMode,

      appodealInterstitialEnabled,
      appodealInterstitialPlacement,

      appodealRewardedEnabled,
      appodealRewardedPlacement,

      appodealBannerEnabled,
      appodealBannerPlacement,

      appodealMrecEnabled,
      appodealMrecPlacement,
    });

    // If no changes, don't call API
    if (Object.keys(adsDataApi).length === 0) {
      return;
    }

    dispatch(adsApiData(adsDataApi, adsData?._id));
  };

  const handleChangeSwitch = async (method) => {
    if (!(await guardPermission())) return;
    try {
      if (method === "monetization") {
        const next = !isMonetization;
        setIsMonetization(next);
        await props.switchApi(data?._id, method, next); // send NEW value
      }
    } catch (e) {
      console.error("Error updating switch:", e);
    }
  };

  const handleChangeAds = async () => {
    if (!(await guardPermission())) return;
    const next = !googleAds;
    setGoogleAds(next);
    dispatch(isAdsChange(next, adsData?._id, "google")); // pass desired next state
  };

  const handleChangeLevelPlayAds = async () => {
    if (!(await guardPermission())) return;
    const next = !levelPlayAds;
    setLevelPlayAds(next);
    dispatch(isAdsChange(next, adsData?._id, "levelplay"));
  };

  const handleChangePangleAds = async () => {
    if (!(await guardPermission())) return;
    const next = !pangleAds;
    setPangleAds(next);
    dispatch(isAdsChange(next, adsData?._id, "pangle"));
  };

  const handleChangeInMobiAds = async () => {
    if (!(await guardPermission())) return;
    const next = !inMobiAds;
    setInMobiAds(next);
    dispatch(isAdsChange(next, adsData?._id, "inmobi"));
  };

  const handleChangeAppodealAds = async () => {
    if (!(await guardPermission())) return;

    const next = !appodealAds;
    setAppodealAds(next);

    dispatch(isAdsChange(next, adsData?._id, "appodeal"));
  };

  const handleChangeMetaAds = async () => {
    if (!(await guardPermission())) return;

    const next = !metaAds;
    setMetaAds(next);

    dispatch(isAdsChange(next, adsData?._id, "meta"));
  };

  const handleChangeTopOnAds = async () => {
    if (!(await guardPermission())) return;

    const next = !topOnAds;
    setTopOnAds(next);

    dispatch(isAdsChange(next, adsData?._id, "topon"));
  };

  const currencySymbol = useMemo(
    () => (defaultCurrency?.symbol ? defaultCurrency.symbol : ""),
    [defaultCurrency?.symbol]
  );

  return (
    <div className="payment-setting p-0 mainSetting">
      {/* ===== Monetize Setting ===== */}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 px-1">

        <div></div>
        <Button
          btnName={"Submit"}
          type={"button"}
          onClick={handleSubmit}
          newClass={"submit-btn"}
          style={{ borderRadius: "0.5rem", width: 88, marginLeft: 10 }}
        />
      </div>

      <div className="settingBox row g-3">
        <div className="col-12 col-md-6">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Monetization</h4>
            </div>

            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center ">
                  <p className="m-0 fw-medium">
                    <span>Monetization Switch (enable/disable monetization in app)</span>
                  </p>
                  <FormControlLabel
                    control={
                      <MaterialUISwitch
                        sx={{ m: 1 }}
                        checked={Boolean(isMonetization)}
                        onChange={() => handleChangeSwitch("monetization")}
                      />
                    }
                  />
                </div>

                <div className="col-12 withdrawal-input border-setting">
                  <Input
                    label={"Min Watch Time of hours of Viewership in channel Required for Monetization"}
                    name={"minWatchTime"}
                    type={"number"}
                    value={minWatchTime}
                    errorMessage={error.minWatchTime}
                    placeholder={"Enter Detail..."}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numericValue = Number(value);

                      setMinWatchTime(value);

                      setError((prev) => {
                        let message = "";
                        if (value === "") {
                          message = "Min Watch Time is required !";
                        } else if (
                          !Number.isFinite(numericValue) ||
                          numericValue <= 0
                        ) {
                          message = "Min Watch Time must be > 0.";
                        }
                        return { ...prev, minWatchTime: message };
                      });
                    }}
                  />
                </div>

                <div className="col-12 withdrawal-input border-setting">
                  <Input
                    label={"Minimum Subscriber Count for Monetization Eligibility"}
                    name={"minSubScriber"}
                    type={"number"}
                    value={minSubScriber}
                    errorMessage={error.minSubScriber}
                    placeholder={"Enter Detail..."}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numericValue = Number(value);

                      setMinSubScriber(value);

                      setError((prev) => {
                        let message = "";
                        if (value === "") {
                          message = "Min Subscriber is required !";
                        } else if (
                          !Number.isFinite(numericValue) ||
                          numericValue < 0
                        ) {
                          message = "Min Subscriber must be ≥ 0.";
                        }
                        return { ...prev, minSubScriber: message };
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Earnings */}
        <div className="col-12 col-md-6">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Set Earnings Rate Per Hour Of Viewership For Creator</h4>
            </div>

            <div className="setting-box-body">
              <div className="row withdrawal-input">
                <div className="row">
                  <div className="col-5">
                    <Input label={"Hour"} name={"Hour"} type={"number"} value={1} disabled />
                  </div>
                  <div className="col-1" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <p className="mb-0 mt-4" style={{ fontSize: 22 }}>=</p>
                  </div>
                  <div className="col-6">
                    <Input
                      label={`Earning (${currencySymbol})`}
                      name={"earningPerHour"}
                      type={"number"}
                      value={earningPerHour}
                      errorMessage={error.earningPerHour}
                      placeholder={"Enter Detail..."}
                      onChange={(e) => {
                        const value = e.target.value;
                        const numericValue = Number(value);

                        setEarningPerHour(value);

                        setError((prev) => {
                          let message = "";
                          if (value === "") {
                            message = "Earning per hour is required !";
                          } else if (
                            !Number.isFinite(numericValue) ||
                            numericValue < 0
                          ) {
                            message = "Earning per hour must be ≥ 0.";
                          }
                          return { ...prev, earningPerHour: message };
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ad frequency */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Show Ads After Every {Math.max(1, Number(adDisplayIndex) || 1)} Video Views</h4>
            </div>

            <div className="setting-box-body">
              <div className="row withdrawal-input">
                <div className="row">
                  <div className="col-12">
                    <Input
                      label={"Ad Display Frequency (Number of Videos)"}
                      name={"adDisplayIndex"}
                      type={"number"}
                      value={adDisplayIndex}
                      errorMessage={error.adDisplayIndex}
                      placeholder={"Enter Detail..."}
                      onChange={(e) => {
                        const value = e.target.value;
                        const numericValue = Number(value);

                        setAdDisplayIndex(value);

                        setError((prev) => {
                          let message = "";
                          if (value === "") {
                            message = "Ad Display Frequency is required !";
                          } else if (
                            !Number.isFinite(numericValue) ||
                            numericValue <= 0
                          ) {
                            message = "Ad Display Frequency must be > 0.";
                          }
                          return { ...prev, adDisplayIndex: message };
                        });
                      }}
                    />
                  </div>
                  <div className="col-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Ads Setting ===== */}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 mt-4 px-1">
        <h4 className="settingboxheader mb-0">Ads Setting</h4>
        <Button
          btnName={"Submit"}
          type={"button"}
          onClick={handleSubmitAds}
          newClass={"submit-btn"}
          style={{ borderRadius: "0.5rem", width: 88, marginLeft: 10 }}
        />
      </div>

      <div className="settingBox row g-3">
        <div className="col-12 ">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Google Ad</h4>
            </div>

            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center ">
                  <p className="fw-medium m-0">
                    <span>Google Ad (enable/disable google ads in app)</span>
                  </p>
                  <FormControlLabel
                    control={
                      <MaterialUISwitch
                        sx={{ m: 1 }}
                        checked={Boolean(googleAds)}
                        onChange={handleChangeAds}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* IMA Ads Tags */}
        <div className="col-12">
          <div className="settingBoxOuter ima-tags-box">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">IMA Ads Tags</h4>
              <InfoTooltip title="IMA Ads Tags (Web)" content={imaAdsTagsContent} />
            </div>

            <div className="setting-box-body">
              <div className="col-12 withdrawal-input border-setting pt-2 mt-0">
                <Input
                  labelShow={false}
                  label={"IMA Tag URL 1"}
                  name={"imaTagUrl1"}
                  type={"text"}
                  value={imaTagUrl1}
                  fieldClass={"ima-tag-input"}
                  placeholder={"Enter IMA Tag URL 1..."
                  }
                  onChange={(e) => setImaTagUrl1(e.target.value)}
                />
              </div>
              <div className="col-12 withdrawal-input border-setting pt-2 mt-2">
                <Input
                  labelShow={false}
                  label={"IMA Tag URL 2"}
                  name={"imaTagUrl2"}
                  type={"text"}
                  value={imaTagUrl2}
                  fieldClass={"ima-tag-input"}
                  placeholder={ "Enter IMA Tag URL 2..."
                  }
                  onChange={(e) => setImaTagUrl2(e.target.value)}
                />
              </div>
              <div className="col-12 withdrawal-input border-setting pt-2 mt-2">
                <Input
                  labelShow={false}
                  label={"IMA Tag URL 3"}
                  name={"imaTagUrl3"}
                  type={"text"}
                  value={imaTagUrl3}
                  fieldClass={"ima-tag-input"}
                  placeholder={"Enter IMA Tag URL 3..."
                  }
                  onChange={(e) => setImaTagUrl3(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Android / iOS fields */}
        <div className="col-12 col-md-6">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Android</h4>
              <InfoTooltip title="Android Ads Setting" content={androidAdsContent} />
            </div>

            <div className="setting-box-body">
              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"Android Google Interstitial"}
                  name={"androidGoogleInterstitial"}
                  type={"text"}
                  value={androidGoogleInterstitial}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setAndroidGoogleInterstitial(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"Android Google Native Image Ad"}
                  name={"androidGoogleNative"}
                  type={"text"}
                  value={androidGoogleNative}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setAndroidGoogleNative(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"Android Google Native Video Ad"}
                  name={"androidGoogleNativeVideo"}
                  type={"text"}
                  value={androidGoogleNativeVideo}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setAndroidGoogleNativeVideo(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"Android Google Reward"}
                  name={"androidGoogleReward"}
                  type={"text"}
                  value={androidGoogleReward}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setAndroidGoogleReward(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"Android Interactive Video Ad URL"}
                  name={"androidVideoAdUrl"}
                  type={"text"}
                  value={androidVideoAdUrl}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setAndroidVideoAdUrl(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* iOS */}
        <div className="col-12 col-md-6">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">iOS</h4>
              <InfoTooltip title="iOS Ads Setting" content={iosAdsContent} />
            </div>

            <div className="setting-box-body">
              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"iOS Google Interstitial"}
                  name={"iosGoogleInterstitial"}
                  type={"text"}
                  value={iosGoogleInterstitial}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setIosGoogleInterstitial(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"iOS Google Native Image Ad"}
                  name={"iosGoogleNative"}
                  type={"text"}
                  value={iosGoogleNative}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setIosGoogleNative(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"iOS Google Native Video Ad"}
                  name={"iosGoogleNativeVideo"}
                  type={"text"}
                  value={iosGoogleNativeVideo}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setIosGoogleNativeVideo(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"iOS Google Reward"}
                  name={"iosGoogleReward"}
                  type={"text"}
                  value={iosGoogleReward}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setIosGoogleReward(e.target.value)}
                />
              </div>

              <div className="col-12 withdrawal-input border-setting">
                <Input
                  label={"iOS Interactive Video Ad URL"}
                  name={"iosVideoAdUrl"}
                  type={"text"}
                  value={iosVideoAdUrl}
                  placeholder={"Enter Detail..."}
                  onChange={(e) => setIosVideoAdUrl(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ===== Ad Network per Format + enable toggles ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Ad Network (per format &amp; enable)</h4>
            </div>
            <div className="setting-box-body">
              <p className="text-muted" style={{ fontSize: "13px" }}>
                Choose which network serves each format. Enable the networks you use. Pangle / InMobi need the app update to serve.
              </p>
              <div className="row">
                {[
                  { label: "Rewarded", value: adNetworkRewarded, set: setAdNetworkRewarded },
                  { label: "Interstitial", value: adNetworkInterstitial, set: setAdNetworkInterstitial },
                  { label: "Native", value: adNetworkNative, set: setAdNetworkNative },
                  { label: "Banner", value: adNetworkBanner, set: setAdNetworkBanner },
                ].map((f) => (
                  <div className="col-6 col-lg-3 mb-3" key={f.label}>
                    <label className="fw-medium d-block mb-1">{f.label}</label>
                    <select
                      style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #d0d0d0" }}
                      value={f.value}
                      onChange={(e) => f.set(e.target.value)}
                    >
                      <option value="google">Google AdMob</option>
                      <option value="levelplay">Unity LevelPlay</option>
                      <option value="pangle">Pangle</option>
                      <option value="inmobi">InMobi</option>
                      <option value="appodeal">Appodeal</option>
                      <option value="meta">Meta</option>
                      <option value="topon">TopOn (Android)</option>
                    </select>
                  </div>
                ))}
              </div>
              <div className="row">
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center">
                  <span className="fw-medium">Unity LevelPlay</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(levelPlayAds)} onChange={handleChangeLevelPlayAds} />} />
                </div>
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center">
                  <span className="fw-medium">Pangle</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(pangleAds)} onChange={handleChangePangleAds} />} />
                </div>
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center">
                  <span className="fw-medium">InMobi</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(inMobiAds)} onChange={handleChangeInMobiAds} />} />
                </div>
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center mt-2 mt-lg-0">
                  <span className="fw-medium">Appodeal</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(appodealAds)} onChange={handleChangeAppodealAds} />} />
                </div>
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center mt-2 mt-lg-0">
                  <span className="fw-medium">Meta</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(metaAds)} onChange={handleChangeMetaAds} />} />
                </div>
                <div className="col-12 col-lg-4 d-flex justify-content-between align-items-center mt-2 mt-lg-0">
                  <span className="fw-medium">TopOn</span>
                  <FormControlLabel control={<MaterialUISwitch sx={{ m: 1 }} checked={Boolean(topOnAds)} onChange={handleChangeTopOnAds} />} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Unity LevelPlay ad units ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Unity LevelPlay Ad Units</h4>
            </div>
            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h6>Android</h6>
                  <div className="mb-2"><Input label={"App Key"} name={"androidLevelPlayAppKey"} type={"text"} value={androidLevelPlayAppKey} placeholder={"levelplay_app_key"} onChange={(e) => setAndroidLevelPlayAppKey(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"androidLevelPlayReward"} type={"text"} value={androidLevelPlayReward} placeholder={"rewarded_ad_unit_id"} onChange={(e) => setAndroidLevelPlayReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"androidLevelPlayInterstitial"} type={"text"} value={androidLevelPlayInterstitial} placeholder={"interstitial_ad_unit_id"} onChange={(e) => setAndroidLevelPlayInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"androidLevelPlayBanner"} type={"text"} value={androidLevelPlayBanner} placeholder={"banner_ad_unit_id"} onChange={(e) => setAndroidLevelPlayBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"androidLevelPlayNative"} type={"text"} value={androidLevelPlayNative} placeholder={"native_ad_unit_id"} onChange={(e) => setAndroidLevelPlayNative(e.target.value)} /></div>
                </div>
                <div className="col-12 col-lg-6">
                  <h6>iOS</h6>
                  <div className="mb-2"><Input label={"App Key"} name={"iosLevelPlayAppKey"} type={"text"} value={iosLevelPlayAppKey} placeholder={"levelplay_app_key"} onChange={(e) => setIosLevelPlayAppKey(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"iosLevelPlayReward"} type={"text"} value={iosLevelPlayReward} placeholder={"rewarded_ad_unit_id"} onChange={(e) => setIosLevelPlayReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"iosLevelPlayInterstitial"} type={"text"} value={iosLevelPlayInterstitial} placeholder={"interstitial_ad_unit_id"} onChange={(e) => setIosLevelPlayInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"iosLevelPlayBanner"} type={"text"} value={iosLevelPlayBanner} placeholder={"banner_ad_unit_id"} onChange={(e) => setIosLevelPlayBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"iosLevelPlayNative"} type={"text"} value={iosLevelPlayNative} placeholder={"native_ad_unit_id"} onChange={(e) => setIosLevelPlayNative(e.target.value)} /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Pangle ad units ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Pangle Ad Units</h4>
            </div>
            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h6>Android</h6>
                  <div className="mb-2"><Input label={"App ID"} name={"androidPangleAppId"} type={"text"} value={androidPangleAppId} placeholder={"pangle_app_id"} onChange={(e) => setAndroidPangleAppId(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"androidPangleReward"} type={"text"} value={androidPangleReward} placeholder={"rewarded_slot_id"} onChange={(e) => setAndroidPangleReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"androidPangleInterstitial"} type={"text"} value={androidPangleInterstitial} placeholder={"interstitial_slot_id"} onChange={(e) => setAndroidPangleInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"androidPangleBanner"} type={"text"} value={androidPangleBanner} placeholder={"banner_slot_id"} onChange={(e) => setAndroidPangleBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"androidPangleNative"} type={"text"} value={androidPangleNative} placeholder={"native_slot_id"} onChange={(e) => setAndroidPangleNative(e.target.value)} /></div>
                </div>
                <div className="col-12 col-lg-6">
                  <h6>iOS</h6>
                  <div className="mb-2"><Input label={"App ID"} name={"iosPangleAppId"} type={"text"} value={iosPangleAppId} placeholder={"pangle_app_id"} onChange={(e) => setIosPangleAppId(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"iosPangleReward"} type={"text"} value={iosPangleReward} placeholder={"rewarded_slot_id"} onChange={(e) => setIosPangleReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"iosPangleInterstitial"} type={"text"} value={iosPangleInterstitial} placeholder={"interstitial_slot_id"} onChange={(e) => setIosPangleInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"iosPangleBanner"} type={"text"} value={iosPangleBanner} placeholder={"banner_slot_id"} onChange={(e) => setIosPangleBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"iosPangleNative"} type={"text"} value={iosPangleNative} placeholder={"native_slot_id"} onChange={(e) => setIosPangleNative(e.target.value)} /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== InMobi ad units ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">InMobi Ad Units</h4>
            </div>
            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h6>Android</h6>
                  <div className="mb-2"><Input label={"Account ID"} name={"androidInMobiAccountId"} type={"text"} value={androidInMobiAccountId} placeholder={"inmobi_account_id"} onChange={(e) => setAndroidInMobiAccountId(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"androidInMobiReward"} type={"text"} value={androidInMobiReward} placeholder={"reward_placement_id"} onChange={(e) => setAndroidInMobiReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"androidInMobiInterstitial"} type={"text"} value={androidInMobiInterstitial} placeholder={"interstitial_placement_id"} onChange={(e) => setAndroidInMobiInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"androidInMobiBanner"} type={"text"} value={androidInMobiBanner} placeholder={"banner_placement_id"} onChange={(e) => setAndroidInMobiBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"androidInMobiNative"} type={"text"} value={androidInMobiNative} placeholder={"native_placement_id"} onChange={(e) => setAndroidInMobiNative(e.target.value)} /></div>
                </div>
                <div className="col-12 col-lg-6">
                  <h6>iOS</h6>
                  <div className="mb-2"><Input label={"Account ID"} name={"iosInMobiAccountId"} type={"text"} value={iosInMobiAccountId} placeholder={"inmobi_account_id"} onChange={(e) => setIosInMobiAccountId(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Reward"} name={"iosInMobiReward"} type={"text"} value={iosInMobiReward} placeholder={"reward_placement_id"} onChange={(e) => setIosInMobiReward(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Interstitial"} name={"iosInMobiInterstitial"} type={"text"} value={iosInMobiInterstitial} placeholder={"interstitial_placement_id"} onChange={(e) => setIosInMobiInterstitial(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Banner"} name={"iosInMobiBanner"} type={"text"} value={iosInMobiBanner} placeholder={"banner_placement_id"} onChange={(e) => setIosInMobiBanner(e.target.value)} /></div>
                  <div className="mb-2"><Input label={"Native"} name={"iosInMobiNative"} type={"text"} value={iosInMobiNative} placeholder={"native_placement_id"} onChange={(e) => setIosInMobiNative(e.target.value)} /></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Meta Ad Units ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Meta Ads</h4>
              <FormControlLabel
                control={
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    checked={Boolean(metaAds)}
                    onChange={handleChangeMetaAds}
                  />
                }
              />
            </div>

            <div className="setting-box-body">
              <div className="row">
                {/* Android */}
                <div className="col-12 col-lg-6">
                  <h6>Android</h6>

                  <div className="mb-2">
                    <Input
                      label={"App ID"}
                      name={"androidMetaAppId"}
                      type={"text"}
                      value={androidMetaAppId}
                      placeholder={"meta_app_id"}
                      onChange={(e) => setAndroidMetaAppId(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Interstitial"}
                      name={"androidMetaInterstitial"}
                      type={"text"}
                      value={androidMetaInterstitial}
                      placeholder={"meta_interstitial"}
                      onChange={(e) => setAndroidMetaInterstitial(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Reward"}
                      name={"androidMetaReward"}
                      type={"text"}
                      value={androidMetaReward}
                      placeholder={"meta_reward"}
                      onChange={(e) => setAndroidMetaReward(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Banner"}
                      name={"androidMetaBanner"}
                      type={"text"}
                      value={androidMetaBanner}
                      placeholder={"meta_banner"}
                      onChange={(e) => setAndroidMetaBanner(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Native"}
                      name={"androidMetaNative"}
                      type={"text"}
                      value={androidMetaNative}
                      placeholder={"meta_native"}
                      onChange={(e) => setAndroidMetaNative(e.target.value)}
                    />
                  </div>
                </div>

                {/* iOS */}
                <div className="col-12 col-lg-6">
                  <h6>iOS</h6>

                  <div className="mb-2">
                    <Input
                      label={"App ID"}
                      name={"iosMetaAppId"}
                      type={"text"}
                      value={iosMetaAppId}
                      placeholder={"meta_app_id"}
                      onChange={(e) => setIosMetaAppId(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Interstitial"}
                      name={"iosMetaInterstitial"}
                      type={"text"}
                      value={iosMetaInterstitial}
                      placeholder={"meta_interstitial"}
                      onChange={(e) => setIosMetaInterstitial(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Reward"}
                      name={"iosMetaReward"}
                      type={"text"}
                      value={iosMetaReward}
                      placeholder={"meta_reward"}
                      onChange={(e) => setIosMetaReward(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Banner"}
                      name={"iosMetaBanner"}
                      type={"text"}
                      value={iosMetaBanner}
                      placeholder={"meta_banner"}
                      onChange={(e) => setIosMetaBanner(e.target.value)}
                    />
                  </div>

                  <div className="mb-2">
                    <Input
                      label={"Native"}
                      name={"iosMetaNative"}
                      type={"text"}
                      value={iosMetaNative}
                      placeholder={"meta_native"}
                      onChange={(e) => setIosMetaNative(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== TopOn Ad Units (Android only) ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">TopOn Ads</h4>
              <FormControlLabel
                control={
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    checked={Boolean(topOnAds)}
                    onChange={handleChangeTopOnAds}
                  />
                }
              />
            </div>

            <div className="setting-box-body">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <h6>Android</h6>

                  {topOnFields.map(([key, label]) => (
                    <div className="mb-2" key={key}>
                      <Input
                        label={label}
                        name={`androidTopOn${key[0].toUpperCase()}${key.slice(1)}`}
                        type={"text"}
                        value={androidTopOn[key] || ""}
                        placeholder={`topon_${key}`}
                        onChange={(e) => setAndroidTopOn((prev) => ({ ...prev, [key]: e.target.value }))}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Appodeal ===== */}
        <div className="col-12">
          <div className="settingBoxOuter">
            <div className="settingBoxHeader d-flex justify-content-between align-items-center px-2">
              <h4 className="settingboxheader">Appodeal</h4>

              <FormControlLabel
                control={
                  <MaterialUISwitch
                    sx={{ m: 1 }}
                    checked={Boolean(appodealAds)}
                    onChange={handleChangeAppodealAds}
                  />
                }
              />
            </div>

            <div className="setting-box-body">
              <div className="row">

                <div className="col-12 col-lg-6">
                  <Input
                    label={"Android App Key"}
                    name={"appodealAndroidAppKey"}
                    type={"text"}
                    value={appodealAndroidAppKey}
                    placeholder={"appodeal_android_app_key"}
                    onChange={(e) => setAppodealAndroidAppKey(e.target.value)}
                  />
                </div>

                <div className="col-12 col-lg-6">
                  <Input
                    label={"iOS App Key"}
                    name={"appodealIosAppKey"}
                    type={"text"}
                    value={appodealIosAppKey}
                    placeholder={"appodeal_ios_app_key"}
                    onChange={(e) => setAppodealIosAppKey(e.target.value)}
                  />
                </div>

                <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                  <span className="fw-medium">Test Mode</span>

                  <FormControlLabel
                    control={
                      <MaterialUISwitch
                        sx={{ m: 1 }}
                        checked={Boolean(appodealTestMode)}
                        onChange={() =>
                          setAppodealTestMode((prev) => !prev)
                        }
                      />
                    }
                  />
                </div>

                {/* Interstitial */}
                <div className="col-12 col-lg-6 mt-3">
                  <h6>Interstitial</h6>

                  <FormControlLabel
                    label="Enabled"
                    control={
                      <Switch
                        checked={Boolean(appodealInterstitialEnabled)}
                        onChange={(e) =>
                          setAppodealInterstitialEnabled(e.target.checked)
                        }
                      />
                    }
                  />

                  <Input
                    label={"Placement"}
                    name={"appodealInterstitialPlacement"}
                    type={"text"}
                    value={appodealInterstitialPlacement}
                    placeholder={"default"}
                    onChange={(e) =>
                      setAppodealInterstitialPlacement(e.target.value)
                    }
                  />
                </div>

                {/* Rewarded */}
                <div className="col-12 col-lg-6 mt-3">
                  <h6>Rewarded</h6>

                  <FormControlLabel
                    label="Enabled"
                    control={
                      <Switch
                        checked={Boolean(appodealRewardedEnabled)}
                        onChange={(e) =>
                          setAppodealRewardedEnabled(e.target.checked)
                        }
                      />
                    }
                  />

                  <Input
                    label={"Placement"}
                    name={"appodealRewardedPlacement"}
                    type={"text"}
                    value={appodealRewardedPlacement}
                    placeholder={"default"}
                    onChange={(e) =>
                      setAppodealRewardedPlacement(e.target.value)
                    }
                  />
                </div>

                {/* Banner */}
                <div className="col-12 col-lg-6 mt-3">
                  <h6>Banner</h6>

                  <FormControlLabel
                    label="Enabled"
                    control={
                      <Switch
                        checked={Boolean(appodealBannerEnabled)}
                        onChange={(e) =>
                          setAppodealBannerEnabled(e.target.checked)
                        }
                      />
                    }
                  />

                  <Input
                    label={"Placement"}
                    name={"appodealBannerPlacement"}
                    type={"text"}
                    value={appodealBannerPlacement}
                    placeholder={"default"}
                    onChange={(e) =>
                      setAppodealBannerPlacement(e.target.value)
                    }
                  />
                </div>

                {/* MREC */}
                <div className="col-12 col-lg-6 mt-3">
                  <h6>MREC</h6>

                  <FormControlLabel
                    label="Enabled"
                    control={
                      <Switch
                        checked={Boolean(appodealMrecEnabled)}
                        onChange={(e) =>
                          setAppodealMrecEnabled(e.target.checked)
                        }
                      />
                    }
                  />

                  <Input
                    label={"Placement"}
                    name={"appodealMrecPlacement"}
                    type={"text"}
                    value={appodealMrecPlacement}
                    placeholder={"default"}
                    onChange={(e) =>
                      setAppodealMrecPlacement(e.target.value)
                    }
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, {
  getSettingApi,
  editSetting,
  switchApi,
  getAdsApi,
  getWithdrawalApi,
})(MonetizationSetting);
